import { Box, Typography } from '@mui/material';
import { Chat, Clock, Notepad } from 'phosphor-react';
import { ModalKit } from './UI';
import { Note } from '../Utilis/Types/Notes';
import { convertDate } from './Strategies/TaskList';

type NoteProps = {
  open: boolean;
  handleClose: () => void;
  note: Note;
  getNoteIdFromNoteBody: (body: string) => string;
};

const NotesModal = ({
  open,
  handleClose,
  note,
  getNoteIdFromNoteBody,
}: NoteProps) => {
  const messageTime = true;
  const ModalBody = () => (
    <Box padding={'32px'}>
      <Typography
        fontSize={'14px'}
        lineHeight={'19px'}
        fontWeight={'400'}
        color={'#736977'}
        dangerouslySetInnerHTML={{
          __html: `Received this email update from ${
            note.added_by
          }  ${convertDate(note.created_at, messageTime)}`,
        }}
      />

      <Typography
        fontSize={'14px'}
        lineHeight={'19px'}
        fontWeight={'400'}
        color={'#736977'}
        dangerouslySetInnerHTML={{ __html: getNoteIdFromNoteBody(note.body) }}
      />

      <Box
        sx={{
          display: 'flex',
          gap: '26.5px',
          marginBottom: '38px',
        }}
        justifyContent={'flex-end'}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
          fontSize={'14px'}
          lineHeight={'19px'}
          fontWeight={'400'}
          color={'#655C68'}
        >
          <Notepad size={20} color={'#655C68'} />
          {note.category}
        </Typography>{' '}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10.5px',
          }}
        >
          <Clock size={20} color='#655C68' />
          <Typography
            fontSize={'14px'}
            lineHeight={'19px'}
            fontWeight={'400'}
            color={'#655C68'}
          >
            {convertDate(note.updated_at)}
          </Typography>
        </Box>
      </Box>
      {note?.comments?.map((comment, i) => (
        <Box
          key={i}
          sx={{
            marginBottom: '10px',
            borderTop: '0.5px solid #E3DDE6',
            paddingTop: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10.5px',
            }}
          >
            <Chat size={20} color='#655C68' />
            <Typography
              fontSize={'14px'}
              lineHeight={'19px'}
              fontWeight={'400'}
              color={'#736977'}
              sx={{
                '& p': {
                  margin: '0',
                },
              }}
              dangerouslySetInnerHTML={{
                __html: comment.content?.replace('<br />&nbsp;', ''),
              }}
            />
          </Box>
          <Typography
            sx={{
              display: 'flex',
              alignItems: 'center',
              wordSpacing: '4px',
            }}
            fontSize={'14px'}
            lineHeight={'19px'}
            fontWeight={'400'}
            color={'#655C68'}
            gap={'10px'}
            fontFamily={'Open Sans, sans-serif'}
          >
            <Clock size={20} color='#655C68' />
            {convertDate(comment.created_at, messageTime)}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  return (
    <div>
      <ModalKit
        title='Note Details'
        titleProps={{
          textAlign: 'left',
          fontWeight: '600',
          fontSize: '16px',
          color: '#202A2D',
          lineHeight: '17px',
        }}
        open={open}
        handleClose={handleClose}
      >
        <ModalBody />
      </ModalKit>
    </div>
  );
};

export default NotesModal;
